import React, { useRef, useEffect, useCallback, useState} from 'react';
import {ChromePicker} from 'react-color';
import {lstorage} from 'utils/lstorage.js';
import ipfs from 'decentralized/Ipfs.js';
import {getWallpapers, newWallpaper} from 'decentralized/settings/appearance.js';
import {useScroll} from 'components/selector2/useScroll.js';
import {
    setTheme,
    setShowThemeGrid,
    setBackgroundColor,
    setWallpaper,
    setAnimateWallpaper,
} from 'actions/index.js';
import ImageHandler from 'components/explore/lists/ImageHandler.js';
import {connect} from 'react-redux';

const Appearance = (props) => { 
    let ref = useRef(undefined);
    let [imageHash, setImageHash] = useState(props.wallpaper);
    let [wallpapers, setWallpapers] = useState(undefined);
    let [showColors, setShowColors] = useState(false);
    let [color, setColor] = useState({hex: props.backgroundColor});

    useEffect(() => {
        if (props.backgroundColor !== color.hex) {
            props.setBackgroundColor(color.hex);
        }
    }, [color, props.backgroundColor]);

    let {size} = useScroll(ref, 9, true);

    useEffect(() => {
        if (imageHash)  {
            lstorage.setItem("wallpaper", imageHash);
            if (wallpapers && !wallpapers.map(x => x.wallpaper).includes(imageHash)) {
                newWallpaper(imageHash);
            }
            props.setWallpaper(imageHash);
        }
    }, [imageHash, wallpapers]);

    useEffect(() => {
        getWallpapers().then(setWallpapers);
    }, [setWallpapers]);

    let _wallpapers = wallpapers || [];
    return (
        <div className="appearance">
          <div className="wallpaper-toolbar">
            Theme:
           <div
              onClick={() => {
                  lstorage.removeItem("wallpaper");
                  lstorage.setItem("theme", "dark");
                  props.setTheme("dark");
                  props.setWallpaper(undefined);
              }}
              className={!props.wallpaper && props.theme == "dark" ?  "wall animate-btn selected" : "wall animate-btn"}>
              Dark Mode
            </div>
           <div
              onClick={() => {
                  lstorage.removeItem("wallpaper");
                  lstorage.setItem("theme", "light");
                  props.setWallpaper(undefined);
                  props.setTheme("light");
              }}
              className={!props.wallpaper && props.theme === "light" ?  "wall animate-btn selected" : "wall animate-btn"}>
              Light Mode
            </div>
           <div
              onClick={() => {
                  lstorage.removeItem("show-theme-grid");
                  lstorage.setItem("show-theme-grid", !props.showThemeGrid);
                  props.setShowThemeGrid(!props.showThemeGrid);
              }}
              className={props.showThemeGrid ?  "wall animate-btn selected" : "wall animate-btn"}>
              Show Grid
            </div>
            <div
              style={{backgroundColor: color.hex}}
              onClick={() => setShowColors(!showColors)} className="color-btn">

            </div>
            {showColors && <ChromePicker color={color} onChange={setColor}/>}
          </div>
          <ImageHandler placeholder="Drag new wallpaper here" imageHash={imageHash} setImageHash={setImageHash}/>
          <div ref={ref} className="gallery">
            {_wallpapers.slice(0, size).map(
                ({wallpaper, thumbnail}) =>
                    <img
                      key={wallpaper}
                      onClick={() => setImageHash(wallpaper)}
                      src={ipfs.getHashUrl(thumbnail)}
                      className="wallpaper-choice"/>)}
          </div>
        </div>
    );
}

const mapStateToProps = (state, props) => {
  return {
      theme: state.sequencer.theme,
      wallpaper: state.sequencer.wallpaper,
      animateWallpaper: state.sequencer.animateWallpaper,
      backgroundColor: state.sequencer.backgroundColor,
      showThemeGrid: state.sequencer.showThemeGrid,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
      setShowThemeGrid: x => dispatch(setShowThemeGrid(x)),
      setTheme: x=> dispatch(setTheme(x)),
      setWallpaper: w => dispatch(setWallpaper(w)),
      setBackgroundColor: w => dispatch(setBackgroundColor(w)),
      setAnimateWallpaper: w => dispatch(setAnimateWallpaper(w)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Appearance);
